/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} What_To_Hear_AboutInputs */

const th_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรื่องที่ต้องการรับแจ้ง`)
};

const en_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to hear about`)
};

const ja_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知する内容`)
};

const zh_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你想收到哪些消息`)
};

const es_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De qué quieres enterarte`)
};

const pt_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o que você quer saber`)
};

const id_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang ingin Anda dengar`)
};

const fr_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce dont vous voulez être informé`)
};

const tl_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang nais mong mabalitaan`)
};

const vi_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn muốn nghe về điều gì`)
};

const ko_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 소식을 받을지`)
};

const de_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worüber du informiert wirst`)
};

const ru_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О чём вас уведомлять`)
};

const tr_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neleri duymak istiyorsunuz`)
};

const it_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di cosa vuoi essere avvisato`)
};

const pl_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O czym chcesz wiedzieć`)
};

const uk_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про що вас сповіщати`)
};

const hi_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप किस बारे में जानना चाहते हैं`)
};

const ar_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما الذي تريد معرفته`)
};

const ms_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang anda mahu tahu`)
};

const bn_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী নিয়ে জানতে চান`)
};

const zh_tw2_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你想收到哪些消息`)
};

const zh_hk2_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你想收到哪些消息`)
};

const ur_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کس بارے میں جاننا چاہتے ہیں`)
};

const fa_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دربارهٔ چه می‌خواهید بدانید`)
};

const sw_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unachotaka kujua`)
};

const nl_what_to_hear_about = /** @type {(inputs: What_To_Hear_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarover je bericht wilt`)
};

/**
* | output |
* | --- |
* | "What to hear about" |
*
* @param {What_To_Hear_AboutInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const what_to_hear_about = /** @type {((inputs?: What_To_Hear_AboutInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<What_To_Hear_AboutInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_what_to_hear_about(inputs)
	if (locale === "ja") return ja_what_to_hear_about(inputs)
	if (locale === "zh") return zh_what_to_hear_about(inputs)
	if (locale === "es") return es_what_to_hear_about(inputs)
	if (locale === "pt") return pt_what_to_hear_about(inputs)
	if (locale === "id") return id_what_to_hear_about(inputs)
	if (locale === "fr") return fr_what_to_hear_about(inputs)
	if (locale === "tl") return tl_what_to_hear_about(inputs)
	if (locale === "vi") return vi_what_to_hear_about(inputs)
	if (locale === "ko") return ko_what_to_hear_about(inputs)
	if (locale === "de") return de_what_to_hear_about(inputs)
	if (locale === "ru") return ru_what_to_hear_about(inputs)
	if (locale === "tr") return tr_what_to_hear_about(inputs)
	if (locale === "it") return it_what_to_hear_about(inputs)
	if (locale === "pl") return pl_what_to_hear_about(inputs)
	if (locale === "uk") return uk_what_to_hear_about(inputs)
	if (locale === "hi") return hi_what_to_hear_about(inputs)
	if (locale === "ar") return ar_what_to_hear_about(inputs)
	if (locale === "ms") return ms_what_to_hear_about(inputs)
	if (locale === "bn") return bn_what_to_hear_about(inputs)
	if (locale === "zh-TW") return zh_tw2_what_to_hear_about(inputs)
	if (locale === "zh-HK") return zh_hk2_what_to_hear_about(inputs)
	if (locale === "ur") return ur_what_to_hear_about(inputs)
	if (locale === "fa") return fa_what_to_hear_about(inputs)
	if (locale === "sw") return sw_what_to_hear_about(inputs)
	if (locale === "nl") return nl_what_to_hear_about(inputs)
	return en_what_to_hear_about(inputs)
});